import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { apiUrl } from '../../config/api-url';
import { ErrorhandlerService } from './errorhandler.service';
import { requestPayload } from '../models/model';
import { AuthorizationService } from './authorization.service';
import config from '../../../assets/config.json';
@Injectable({
  providedIn: 'root',
})
export class SeminarPageService {
  private readonly apiUrl = environment.apiHost; // Use HTTPS and secure URLs
  private readonly endPoints = apiUrl;
  //temporary json file path
  private seminarPageJsonUrl = '../../../assets/dummyjsons/seminarpage.json';
  configData: any = config;
  constructor(
    private _http: HttpClient,
    private _errorHandlerService: ErrorhandlerService,
    private _authservice: AuthorizationService,
  ) {}

  getSeminarPageDataFromJson(): Observable<any> {
    return this._http.get<any>(this.seminarPageJsonUrl);
  }

  getSeminarPageData(body: requestPayload): Observable<any> {
    const httpHeaderOptions: { headers: HttpHeaders } = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };
    return this._http.post<any>(this.apiUrl + this.endPoints.getResources, body, httpHeaderOptions).pipe(
      catchError((error: HttpErrorResponse) => this._errorHandlerService.handleError(error)), // Use the centralized error handler
    );
  }
}
